import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../../../../../shared/button/button.component";
import { ElementMessageComponent } from "./element-message/element-message.component";
import { DiaryFormElementMessage } from "../../../../../core/models/trial-diary-form/diary-form-element-message.model";

@Component({
  selector: 'app-element-messages',
  standalone: true,
  imports: [
    ButtonComponent,
    ElementMessageComponent
  ],
  templateUrl: './element-messages.component.html',
  styleUrl: './element-messages.component.scss'
})
export class ElementMessagesComponent {
  @Input('expanded') expanded: boolean = false;
  @Input('messages') messages: DiaryFormElementMessage[] = [];

  @Output('closed') closed = new EventEmitter();
  @Output('editClick') editClick = new EventEmitter<number>();
  @Output('removeClick') removeClick = new EventEmitter<number>();
  @Output('addClick') addClick = new EventEmitter();

  getMessageText(message: DiaryFormElementMessage): string {
    return message.translations.find(t => t.culture === 'en')?.text ?? '';
  }

  getMessageVariant(message: DiaryFormElementMessage): 'danger' | 'warning' | 'success' | 'info' | 'placeholder' {
    const validVariants = ['danger', 'warning', 'success', 'info', 'placeholder'];
    return validVariants.includes(message.style) ? message.style as any : 'placeholder';
  }
}
